// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navbar-NavLink-module--nav-link--1o1Xz"};